import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
    const token = localStorage.getItem('token');
    
    // In a real app, you might also check token expiration here
    return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
